import { Modal } from '@simplywallst/ui-core';

interface Props {
  onClose: () => void;
  watchlistsLimit: number;
}

const WatchlistsLimitModal = ({ onClose, watchlistsLimit }: Props) => {
  return (
    <Modal
      title={`You can only create ${watchlistsLimit} watchlists`}
      onPrimaryClick={onClose}
      onClose={onClose}
      primaryLabel="Okay"
      fullscreen={true}
    >
      <>
        <p>You've reached the limit of {watchlistsLimit} Watchlists.</p>
        <p>
          We're currently working on improving this feature and allowing
          investors to track more companies at the same time.
        </p>
        <p>
          Please let us know how we can help you manage your watchlist better
          through this{' '}
          <a
            href="https://surveys.hotjar.com/572b1d1a-ba64-4401-b02f-b57209982ba5"
            target="_blank"
            rel="noreferrer noopener nofollow"
          >
            quick 2 minute survey
          </a>
          .
        </p>
      </>
    </Modal>
  );
};

export default WatchlistsLimitModal;
